<template>
  <div>
    <div class="footer__layout">
    <div class="footer-box">
      <div class="footer-left">
        <div class="contact">
          <p>联系我们</p>
          <p>温馨提示：市场有风险，投资需谨慎，最终收益以实际为准</p>
        </div>
        <div class="contact-information">
          <div>
            <p>客服邮箱</p>
            <p>cs@rlcvipltd.net</p>
          </div>
          <div>
            <p>公司地点</p>
            <p>九龍尖沙咀漆咸道南87-105<br />號百利商業中心</p>
          </div>
          <div>
            <p>联系电话</p>
            <p>(852) 23927848</p>
          </div>
        </div>
        <div class="copyright">COPYRIGHT(©) 2026 红狮金业</div>
      </div>
      <div class="footer-right">
        <ul>
          <li>应用名称：红狮</li>
          <router-link to="/Application">
            <li>应用权限：查看权限</li>
          </router-link>
          <li>更新时间：2025年01月07日</li>
          <li>APP开发者：红狮金业有限公司</li>
          <li>应用版本：5.0.3</li>
          <router-link to="/Privacy">
            <li>隐私权限：查看权限</li>
          </router-link>
          <li>红狮金业有限公司是香港黄金交易所AA类行员，行员编号：081</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="wapBox">
   <div class="wap_layout">
    <div class="tips1">
        <ul>
          <li>
            <div class="flex">
              <span class="title">联系我们</span>
              <span class="lines"></span>
            </div>
          </li>

        </ul>
        
      </div>

      <div class="tips">
        <ul>
          <li>应用名称：红狮</li>
          <li @click="checkPower(1)" style="cursor: pointer">
            应用权限：查看权限
          </li>
          <li>更新时间：2025年01月07日</li>
          <li>APP开发者：红狮金业有限公司</li>
          <li>应用版本：5.0.3</li>
          <li @click="checkPower(2)" style="cursor: pointer">
            隐私权限：查看权限
          </li>
          <li>红狮金业有限公司是香港黄金交易所AA类行员，行员编号：081</li>
        </ul>
        <div class="rightbox">
          <ul>
           <li>
          <p>
            <span>客服邮箱</span>
            <span class="tit">cs@rlcvipltd.net</span>
          </p>
          <p>
            <span>公司地址</span>
            <span class="tit">九龍尖沙咀漆<br />咸道南87-105號百<br />利商業中心</span>
          </p>
          <p>
            <span>联系电话</span>
            <span class="tit">(852) 23927848</span>
          </p>
        </li>
        </ul>
        </div>
      </div>
      <div class="copyRight">COPYRIGHT(©) 2026 {{ $store.state.common.appName }}</div>
      <div class="copyRight" style="margin-top:0;color: #93939F;">市场有风险，投资需谨慎，最终受益以实际为准</div>
  </div>
  </div>
  </div>
 
</template>

<script>
export default {
  data() {
    return {
      control: true,
    };
  },
  created() {
    if (window.location.origin.indexOf("xsintlg") !== -1) {
      this.control = false;
    }
  },
  methods: {
    // 跳转查看权限
    checkPower(attr) {
      if (attr == 1) {
        this.$router.push({
          name: "Application",
        });
     
      } else if (attr == 2) {
        this.$router.push({
          name: "Privacy",
        });
      } else {
        this.$router.push({
          name: "Functiong",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.footer__layout {
  display: block;
  background-color: #0A0A0A;
  color: #FFFFFF;
  padding: 70px 0;

  .footer-box {
    width: 1240px;
    margin: auto;
    display: flex;
    align-items: center;
    font-size: 14px;

    >div {
      width: 50%;
      box-sizing: border-box;
    }

    .footer-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 260px;
      color: #FFFFFF;
      font-size: 14px;

      .contact {
        p {
          &:first-child {
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 6px;
          }
        }
      }
      .contact-information {
        width: 68%;
        display: flex;
        justify-content: space-between;
        >div {
          p {
            font-size: 18px;
            &:last-child {
              color: #93939F;
              font-size: 14px;
              margin-top: 10px;
            }
          }
        }
      }
    }
    .footer-right {
      padding-left: 12%;
      li {
        color: #93939F;
        line-height: 40px;
      }
    }
  }
}
.wapBox{
  display: none;
 
}
.wap_layout{
  background: #0A0A0A;


    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 90px 0;
    .flex {
      display: flex;
      align-items: flex-end;
    }
    .tit {
      color: #616161;
    }
    .lines {
      width: 207px;
      height: 2px;
      background: #ffffff;
      margin-left: 16px;
    }

    .tips1 {
      margin-bottom: 28px;
      ul {
        width: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        // align-items: center;
        box-sizing: border-box;
        padding: 0 28px;
        li {
          display: flex;
          justify-content: space-between;

          // align-items: center;
          p {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            color: #ffffff;
            span {
              line-height: 30px;
            }
            span:nth-child(1) {
              font-weight: 600;
              font-size: 14px;
            }
            span:nth-child(2) {
              font-size: 13px;
            }
          }
        }
      }
    }
    .levelLine {
      width: 100%;
      height: 1px;
      background-color: #393a3c;
      margin: 15px auto 20px;
    }
    .tips {
      width: 100%;
      box-sizing: border-box;
      padding: 0 28px;
      display: flex;
      justify-content: space-between;
      position: relative;
      // align-items: center;
      ul {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0;
        li {
          line-height: 35px;
          font-size: 12px;
          color: #93939F;

          p {
            display: flex;
            flex-direction: column;
          }
        }
      }
      .rightbox {
        
        position: absolute;
        top: -11px;
        right: 34px;
        color: #ffffff;
        ul {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0;
        li {
          line-height: 20px;
          font-size: 12px;
          p {
            display: flex;
            flex-direction: column;
          }
        }
      }
      }
    }
    .title {
      font-size: 24px;
      line-height: 34px;
      font-weight: 700;
      color: #ffffff;
      white-space: nowrap;
    }
    .copyRight {
    text-align: center;
    font-size: 13px;
    margin: 62px 0 30px 0px;
    color: #ffffff;
  }
  
}
@media screen and (max-width: 500px) {
  .footer__layout{
    display: none;
  }
  .wapBox{
    display: block;
  }
}
   // -------------------------小屏幕适配-------------------
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
  .footer__layout {
      display: block;
      background-color: #0A0A0A;
      color: #FFFFFF;
      padding: 70px 0;
  
      .footer-box {
        width: 1000px;
        margin: auto;
        display: flex;
        align-items: center;
        font-size: 14px;
  
        >div {
          width: 50%;
          box-sizing: border-box;
        }
  
        .footer-left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 260px;
          color: #FFFFFF;
          font-size: 14px;
  
          .contact {
            p {
              &:first-child {
                font-size: 32px;
                font-weight: 700;
                margin-bottom: 6px;
              }
            }
          }
  
          .contact-information {
            width: 68%;
            display: flex;
            justify-content: space-between;
  
            >div {
              p {
                font-size: 18px;
  
                &:last-child {
                  color: #93939F;
                  font-size: 14px;
                  margin-top: 10px;
                }
              }
            }
          }
        }
  
        .footer-right {
          padding-left: 12%;
  
          li {
            color: #93939F;
            line-height: 40px;
          }
        }
      }
    }
  }
</style>
